
































































































import Vue, { PropType } from 'vue';
import Component, { mixins } from 'vue-class-component';

import { config } from './config';
import { locales } from './locales';

import { FileUploadCore } from './mixins/fileUploadCore';
import { Widthable } from '../../mixins/widthable';

import { customizable } from '../../mixins/customizable';

import { calcHumanFileSize } from '../../functions/calcHumanFileSize';

import { mdiCloudUpload } from '@mdi/js';

import { IndexedObject } from '../../types';

const Props = Vue.extend({
	props: {
		/** The v-model value */
		value: {
			// File is not a valid prop type, use
			// null to allow any type and
			// provide custom validation
			type: null as unknown as PropType<File | File[] | null>,
			default: null,
			/** @see https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/components/VFileInput/VFileInput.ts#L71 */
			validator: (val): boolean => {
				if (val === null) {
					return true;
				}

				const value = Array.isArray(val) ? val : [val];
				const isValid = value.every((v) => v !== null && typeof v === 'object');

				return isValid;
			}
		},
		/** Allow multiple files */
		multiple: {
			type: Boolean,
			default: false
		},
		/** Disable v-ripple on the component */
		noRipple: {
			type: Boolean,
			default: false
		},
		/** Disable the component */
		disabled: {
			type: Boolean,
			default: false
		}
	}
});

const MixinsDeclaration = mixins(Props, customizable(config), FileUploadCore, Widthable);

/**
 * FileUpload is a component that enhance the default HTML
 * file input element
 */
@Component({
	model: {
		prop: 'value',
		event: 'change'
	}
})
export default class FileUpload extends MixinsDeclaration {
	// Locales
	locales = locales;

	// Icons
	uploadIcon = mdiCloudUpload;

	/** For specific styles on hover */
	hover = false;

	/**
	 * Get the different colors
	 * depending on theme (light or dark)
	 */
	get colors(): IndexedObject {
		const dark = this.$vuetify.theme.dark;

		return {
			label: dark ? 'white--text' : 'primary--text',
			multiple: dark ? 'white--text' : 'black--text',
			info: 'grey--text ' + (dark ? 'text--lighten-1' : 'text--darken-1')
		};
	}

	/** Compute maximum size to human readable */
	get maxSizeReadable(): string {
		return calcHumanFileSize(this.fileSizeMax, this.fileSizeUnits);
	}

	/** Computed extensions for display */
	get extensions(): string {
		return this.allowedExtensions.join(', ').toUpperCase();
	}

	/** Expose retry function which clicks on the input */
	public retry(): void {
		this.$refs.vdInputEl.click();
	}
}
